import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider, type QueryClient } from '@tanstack/react-query';
import { useTranslation } from '@/i18n/useTranslation';
import { AuthProvider } from '@/auth/AuthProvider';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { App } from './App';

export function Application({ queryClient }: { queryClient: QueryClient }) {
  const { t } = useTranslation();
  return (
    <ErrorBoundary boundaryName={t('App')}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </AuthProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
